var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.443 20.375c1.233 0 2.778-.86 3.699-2.005.833-1.038 1.441-2.488 1.441-3.938 0-.196-.017-.393-.052-.554-1.372.053-3.021.948-4.011 2.148-.782.912-1.494 2.344-1.494 3.812 0 .214.035.43.053.5.086.019.225.037.364.037m-4.34 21.656c1.683 0 2.43-1.163 4.531-1.163 2.136 0 2.605 1.127 4.48 1.127 1.84 0 3.074-1.753 4.237-3.472 1.303-1.969 1.84-3.902 1.876-3.991-.122-.036-3.647-1.521-3.647-5.691 0-3.616 2.778-5.245 2.935-5.37-1.841-2.72-4.637-2.792-5.4-2.792-2.067 0-3.752 1.289-4.81 1.289-1.147 0-2.657-1.218-4.446-1.218-3.404 0-6.859 2.9-6.859 8.377 0 3.4 1.285 6.998 2.865 9.325 1.355 1.968 2.535 3.58 4.237 3.58"
  })));
};
export default SvgApple;